import { removeCommas } from '@ps-smart-cp/ppfw-client';
import Decimal from 'decimal.js';

function parseDecimalOrZero(str: string) {
  return Number.isNaN(Number(removeCommas(str))) || str === '' ? Decimal(0) : Decimal(removeCommas(str));
}

export { parseDecimalOrZero };
